import { useState } from "react";
import { Camera } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Dialog } from "@/modern/components/ui/dialog-shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import {
  SharedModal,
  SharedModalBody,
  SharedModalHeader,
  SharedModalTitle,
} from "@/modern/components/shared-modal-component";
import { CompanyCamProjectEditor } from "@/react/components/entityViews/files/components/editors/CompanyCamProjectEditor";
import { cn } from "@/modern/utils";

/** Above Manage files / other Bryntum editor dialogs. */
const ELEVATED_Z = "z-[calc(var(--swivu-bryntum-z-index)+10)]";

type LinkCompanyCamHeaderButtonProps = {
  /** Optional surface override for the trigger (e.g. Manage files toolbar). */
  className?: string;
};

/** Header icon that opens the CompanyCam project linker in a dialog. */
export const LinkCompanyCamHeaderButton = ({
  className,
}: LinkCompanyCamHeaderButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="entityHeader"
            size="icon"
            aria-label="Link Company Cam"
            className={cn(className)}
            onClick={() => setOpen(true)}
          >
            <Camera className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Link Company Cam</TooltipContent>
      </Tooltip>
      <Dialog open={open} onOpenChange={setOpen}>
        <SharedModal
          className={cn(
            "max-h-[85vh] w-[min(100vw-2rem,64rem)] max-w-screen-lg sm:max-w-screen-lg",
            ELEVATED_Z,
          )}
          overlayClassName={ELEVATED_Z}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onCloseAutoFocus={(event) => event.preventDefault()}
        >
          <div className="flex min-h-0 flex-1 flex-col">
            <SharedModalHeader>
              <SharedModalTitle className="max-w-none text-swivu-lg">
                Link company cam project
              </SharedModalTitle>
            </SharedModalHeader>
            <SharedModalBody>
              <CompanyCamProjectEditor onFinish={() => setOpen(false)} />
            </SharedModalBody>
          </div>
        </SharedModal>
      </Dialog>
    </>
  );
};
